module.exports = __webpack_public_path__ + "static/media/icon.f6157b02.png";